// Data is an array of events which have come from the real-time api
// The current requirement for how data is stored in the v2 player is an absolute dogs breakfast.
// The whole thing really needs to be fixed. This parser is not fully implemented as yet, but
// to get an idea for the complexities of the store set up look at the v2-callback parser.
// My apologies if you need to work on this, but it was broken when I got here...
const parse = data => ({
  activeTopic: 0,
  topics: [
    {
      name: 'ALL TOPICS',
      type: 'category',
      keywords: data
        .filter(e => e.type === 'KnowledgeEvent' && e.extractedKeywords)
        .map(e => e.extractedKeywords)
        .reduce((acc, e) => acc.concat(e), []),
    },
    ...data
      .filter(e => e.type === 'KnowledgeEvent' && e.extractedTopics)
      .map(e => e.extractedTopics)
      .reduce((acc, e) => acc.concat(e), [])
      .reduce((acc, t) => acc.set(t.name, t), new Map())
      .values(),
  ],
  activeGroup: 0,
  groups: [
    ...data
      .filter(e => e.type === 'KnowledgeEvent' && e.spottedPhraseGroups)
      .map(e => e.spottedPhraseGroups)
      .reduce((acc, e) => acc.concat(e), [])
      .reduce((acc, t) => acc.set(t.name, t), new Map())
      .values(),
  ],
  activeSpeaker: 0,
  speakers: [],
  transcriptSpeakers: [],
  transcript: [
    ...data
      .filter(e => e.type === 'TranscriptEvent')
      .map(e => e.words)
      .reduce((acc, e) => acc.concat(e), [])
      .map(w => (w.w === '</s>' ? { ...w, w: '...' } : w))
      .reduce((acc, w) => acc.set(w.p, w), new Map())
      .values(),
  ],
  // TODO: Add classifiers if required later.
});

export default parse;
